import { lazy } from 'react';
import { BlockWrapper, defineBlock, smartProps, useEditor, useInspectorControl } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import { ReactComponent as Instagram } from '../../assets/instagram.svg';
import style from './style.module.scss';

const Inspector = lazy(() => import('./inspector.js'));

function Media({ image, url, isInstagramLogo }) {
    const { isEditing } = useEditor();
    useInspectorControl(Inspector);

    const Tag = isEditing || !url ? BlockWrapper.Div : BlockWrapper.A;

    return (
        <Tag href={url} target="_blank" rel="noopener noreferrer" className={style.media}>
            <EditableImg smartProp={'image'} />
            {image && isInstagramLogo && <Instagram className={style.instagramLogo} />}
        </Tag>
    );
}

export default defineBlock({
    Block: Media,
    smartProps: {
        image: smartProps.image,
        url: smartProps.string.withDefault(''),
        isInstagramLogo: smartProps.bool.withDefault(true),
    },
    setup: {
        title: 'Média',
        parent: 'smartfire/social-networks',
    },
});
